/**
 * Bayi panelinin adresi — yönetim panelinden seçilir (Affiliates →
 * Yapılandırma) ve `/settings` yanıtındaki `affiliate_panel` bloğuyla gelir.
 *
 * İki biçimi vardır: sitenin bir yolu (`/ortak`) ya da doğrulanmış ayrı bir
 * alan adı. Alan adı seçiliyse o adresin **her yolu** bayi panelidir; site
 * kabuğu orada hiç çizilmez.
 */
export const DEFAULT_PARTNER_PATH = '/ortak';
const PATH_RE = /^\/[a-z0-9][a-z0-9-]{1,30}$/;

export const partnerPanelPath = (settings) => {
  const path = String(settings?.affiliate_panel?.path || '').trim().toLowerCase();
  return PATH_RE.test(path) ? path : DEFAULT_PARTNER_PATH;
};

const bareHost = (value) => String(value || '').trim().toLowerCase().replace(/^www\./, '');

export const isPartnerHost = (settings, hostname = window.location.hostname) => {
  const host = bareHost(settings?.affiliate_panel?.host);
  return Boolean(host) && bareHost(hostname) === host;
};

/**
 * Affiliates paneli yeni bir alan adına taşındıysa eski adrese gelen
 * ziyaretçinin gideceği adres (aynı yol ve sorgu); yönlendirme yoksa boş.
 * Eski adresler `affiliate_panel.previous_hosts`'tadır (services/affiliate_domain.py).
 */
export const partnerRedirectUrl = (settings, location = window.location) => {
  const host = bareHost(settings?.affiliate_panel?.host);
  const previous = (settings?.affiliate_panel?.previous_hosts || []).map(bareHost);
  if (!host || !previous.includes(bareHost(location.hostname)) || bareHost(location.hostname) === host) return '';
  return `https://${host}${location.pathname || '/'}${location.search || ''}`;
};

/**
 * Bayi paneli ayrı bir alan adına bağlandıysa oyun sitesindeki panel yolu
 * (`/ortak` ve seçilen yol) kalkar: sitede bayi paneli çizilmez, gelen ziyaretçi
 * aynı alt yol ve sorguyla panelin alan adına gider (`/ortak/login` →
 * `https://<alan adı>/login`). Eski yer imleri ve paylaşılmış bağlantılar böylece
 * kırılmaz. Alan adı seçili değilse ya da ziyaretçi zaten oradaysa boş döner.
 */
export const partnerPathRedirectUrl = (settings, location = window.location) => {
  const host = bareHost(settings?.affiliate_panel?.host);
  if (!host || bareHost(location.hostname) === host) return '';
  const pathname = location.pathname || '/';
  const prefix = [partnerPanelPath(settings), DEFAULT_PARTNER_PATH]
    .find((path) => pathname === path || pathname.startsWith(`${path}/`));
  if (!prefix) return '';
  return `https://${host}${pathname.slice(prefix.length) || '/'}${location.search || ''}`;
};

/** Affiliates alan adı adımının durumu: `done` / `current` / `todo` (panel kartı). */
const STAGE_ORDER = ['dns', 'server', 'verify', 'active'];
export const stageState = (stage, key) => {
  if (stage === 'active') return 'done';
  const at = STAGE_ORDER.indexOf(stage);
  const i = STAGE_ORDER.indexOf(key);
  if (at < 0) return 'todo';
  if (i < at) return 'done';
  return i === at ? 'current' : 'todo';
};
